
import Vue from "vue";

export default Vue.extend({
  name: "PopUp",
  props: {
    titulo: String,
    texto: String,
    confirmar: String,
    cancelar: String,
    dialog: Boolean,
    width: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close(): void {
      this.$emit("close");
    },
    salvo(): void {
      this.$emit("ok");
    },
  },
});
